import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import Menu from './Menu';
import { LOGO } from '../images';
import { useMenuContext } from '../contexts/MenuContext';
import { BREAK_POINTS } from '../constants';

const HeaderWrapper = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  width: 100vw;
  height: 200px;
  background-color: #fff;
  z-index: 100;

  @media (max-width: ${BREAK_POINTS.TABLET}px) {
    height: 160px;
  }

  @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    height: 100px;
  }
`;

const HeaderContent = styled.div`
  max-width: 1180px;
  height: 100%;
  margin: 0 auto;
  padding: 40px 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  @media (max-width: ${BREAK_POINTS.TABLET}px) {
    padding: 0 32px;
  }

  @media (max-width: ${BREAK_POINTS.MOBILE}px) {
    padding: 0 20px;
  }
`;

const Logo = styled.div`
  cursor: pointer;

  img {
    height: 120px;
    transition: height 0.3s ease;

    @media (max-width: ${BREAK_POINTS.TABLET}px) {
      height: 100px;
    }

    @media (max-width: ${BREAK_POINTS.MOBILE}px) {
      height: 68px;
    }
  }
`;

const Header = () => {
  const { setIsOpen } = useMenuContext();
  const navigate = useNavigate();

  const onClickLogo = () => {
    setIsOpen(false);
    navigate('/');
  };

  return (
    <HeaderWrapper>
      <HeaderContent>
        <Logo onClick={onClickLogo}>
          <img src={LOGO} alt="logo" />
        </Logo>
        <Menu />
      </HeaderContent>
    </HeaderWrapper>
  );
};

export default Header;
